import { Pressable } from 'react-native';
import { Link } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { ThemedView } from '@/components/themed-view';
import { useAuth } from '@/hooks/use-auth';

export default function LoginScreen() {
  const { devSignIn } = useAuth();

  return (
    <ThemedView className="flex-1 items-center justify-center px-8">
      <ThemedText type="title" className="mb-2 text-5xl text-gold-dark dark:text-gold">
        Pentarchy
      </ThemedText>
      <ThemedText type="muted" className="mb-12">
        A book club for the ages
      </ThemedText>

      <ThemedText type="subtitle" className="mb-8">
        Log In
      </ThemedText>

      <Link href="/signup">
        <ThemedText type="link">Create an account {'\u2192'}</ThemedText>
      </Link>

      {__DEV__ && devSignIn && (
        <Pressable onPress={devSignIn} className="mt-12 rounded border border-gold/30 px-6 py-3">
          <ThemedText type="muted">Dev Login</ThemedText>
        </Pressable>
      )}
    </ThemedView>
  );
}
